import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/relojchecador/justificacion-reloj-checador-grupal/';
export const empleadosCandidatosURI = '/relojchecador/justificacion-reloj-checador-grupal/empleados-candidatos/';

/**
 * GET Justificaciones Reloj Grupales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getJustificacionesGrupalesReloj = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Justificacion Reloj Grupal
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getJustificacionGrupalReloj = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Justificacion Reloj Grupal
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postJustificacionGrupalReloj = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Justificacion Reloj Grupal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchJustificacionGrupalReloj = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Descartar un detalle (empleado + fecha) de una Justificación Grupal
 * @param {number} id id de la Justificación Grupal
 * @param {number} detalleId id del detalle a descartar
 * @returns {Promise<object|boolean>}
 */
export const descartarDetalleJustificacionGrupal = async (id, detalleId) => {
  try {
    const response = await API.post(`${baseURI}${id}/descartar-detalle/`, { detalle_id: detalleId });
    onSuccess(response, 'Registro descartado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Empleados Candidatos para Justificación Grupal
 * @param {object} params
 *   { tipo_de_evaluacion_de_asistencia, fecha_desde, fecha_hasta, directorio_de_area }
 * @returns {Promise<object[]>}
 */
export const getEmpleadosCandidatosGrupal = async (params) => {
  try {
    const response = await API.get(empleadosCandidatosURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
